import React, { StrictMode } from 'react';
import './index.css';
import AppProvider from './AppProvider';
import { createRoot } from 'react-dom/client';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <StrictMode>
        <AppProvider />
    </StrictMode>,
);
